import {
  CommonParamsType,
  CommonSuccessResponse,
} from "constants/types/common";
import { ProductResponseType } from "constants/types/product";
import { useMemo } from "react";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getProductListKey = (params?: CommonParamsType) => {
  return `/product?${serialize({ ...params })}`;
};

export const useProducts = (params?: CommonParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<ProductResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getProductListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const products = data?.data;

  return {
    products,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useListProduct = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<ProductResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR("/product/all", { refreshInterval: 0 });

  const products = data?.data ?? [];

  const productOptions = useMemo(
    () =>
      products.map((product) => ({
        label: product.name,
        value: product.id,
      })),
    [products],
  );

  const productMap = useMemo(
    () =>
      products.reduce<Record<string, ProductResponseType>>((acc, product) => {
        acc[product.id] = product;
        return acc;
      }, {}),
    [products],
  );

  return {
    products,
    productOptions,
    productMap,
    error,
    isLoading,
    mutate,
  };
};
